import React from 'react';
import { Link } from 'react-router-dom';

const InfoSection = () => {
  return (
    <section className="font-sinhala max-w-5xl mx-auto my-16     z-20">
       
      
      <h3 className="text-2xl font-bold text-slate-800 mb-4 flex items-center gap-3">
        <span className="w-8 h-8 rounded-full bg-orange-100 flex items-center justify-center text-orange-500 text-sm">✦</span>
        ඉතා පහසුවෙන් ගනුදෙනු කිරීම සඳහා
      </h3>
      <p className="text-slate-600 mb-6 leading-relaxed">
        කසුන් වලකුඹුර Science අධ්‍යාපන කේන්ද්‍රය සමග ඉතා පහසුවෙන් ගනුදෙනු කිරීම සඳහා පහත දුරකථන අංක භාවිතා කර වට්ස්ඇප්(WhatsApp) පණිවිඩයක් යොමු කරන්න.
      </p>
      
      <div className="bg-gradient-to-br from-orange-500 to-red-600 text-white p-6 rounded-2xl mb-6 shadow-lg shadow-orange-500/20 leading-relaxed font-medium">
        <p className="mb-4 text-orange-50">ඔබට මෙම WebSite එකට Register වීමේදී ගැටළුවක් ඇති වුවහොත් ගැටලුව ඇති තැන screenshot එකක් සමග 0740251710 අංකයට අනිවාර්යයෙන් WhatsApp පණිවිඩයක් එවන්න.</p>
        <ul className="space-y-3">
          <li className="flex items-start gap-3">
            <span className="mt-1 opacity-80">👉</span>
            පන්ති පිළිබඳ වැඩිදුර තොරතුරු අවශ්ය නම් පන්තියේ නම සඳහන් කර 0740251710 WhatsApp කරන්න.
          </li>
        </ul>
      </div>
      
      <p className="text-slate-500 font-medium mb-8 bg-slate-50 inline-block px-4 py-2 rounded-lg">මෙය ඔබට හා අපට ඉතා පහසු බැවින් හොඳින් කියවන්න.</p>
      
      <div className="flex flex-wrap gap-4 mb-10">
        <Link to="/register" className="font-sans inline-block text-center bg-gradient-to-r from-orange-500 to-red-600 text-white font-bold py-3 px-8 rounded-xl shadow-lg shadow-orange-500/30 hover:-translate-y-1 hover:shadow-xl hover:shadow-orange-500/40 transition-all duration-300">
          Register Now
        </Link>
        <Link to="/login" className="font-sans inline-block text-center bg-white text-orange-600 font-bold py-3 px-8 rounded-xl border border-orange-100 hover:bg-orange-50 hover:-translate-y-1 transition-all duration-300">
          Login
        </Link>
      </div>
      
      <div className="pt-8">
        <p className="font-bold text-slate-700 mb-4 flex items-center gap-2">
          WebSite එකට පුරනය(Login) වන ආකාරය <span className="animate-bounce">👇</span>
        </p>
        <div className="w-full max-w-2xl aspect-video bg-slate-900 rounded-2xl flex items-center justify-center text-white shadow-2xl relative overflow-hidden group">
          <div className="absolute inset-0 bg-gradient-to-b from-transparent to-slate-900/80 pointer-events-none"></div>
          <div className="flex items-center gap-2 transform group-hover:scale-110 transition-transform duration-300 cursor-pointer">
            Watch on <span className="text-red-500 font-bold tracking-tighter text-xl">YouTube</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InfoSection;
